<template>
  <section class="newsArticle">
    <PageTitle title="News Article" />
    <div class="newsArticle__wrapper">
      <News class="styleB" v-if="article"
        styleType="News"
        :title="article.title.rendered"
        :image="article.featured_image_url"
        :imageSrcSet="article.featured_image_srcset"
        :date="formatDate(article.date)"
        :text="article.content.rendered"
      />
      <div v-else>
        <h1>Sorry, can't find the article...</h1>
      </div>
    </div>
  </section>
</template>

<script>
import PageTitle from '@/components/blocks/PageTitle'
import News from '@/components/blocks/PicturePanel'
import moment from 'moment'

export default {
  name: 'NewsArticle',
  metaInfo: {
    title: 'News',
    titleTemplate: '%s | GWS'
  },
  components: {
    News, PageTitle
  },
  created () {
    // console.log(this.$route.params.id)
  },
  computed: {
    article () {
      // console.log(this.$store.state.news)
      if (this.$store.state.news.length > 0) {
        return this.$store.state.news.find(n => n.slug === this.$route.params.id)
      } else {
        return null
      }
    }
  },
  methods: {
    formatDate (wpDate) {
      return moment(wpDate).format('Do MMMM YYYY')
    }
  }
}
</script>

<style scoped lang="scss">
.newsArticle {
  &__wrapper {
    @include sectionPadding;
    @include gridWidth;
  }
  ::v-deep .picturepanel {
    &__text p {
      margin-bottom: vr(2);
      line-height: vr(1.2);
    }
    &__title {
      @media(min-width: $md) {
        @include fontsize(1.75);
        width: 50%;
      }
    }
  }
}
</style>
